import React, { useState, useRef } from "react";
import { Badge, Typography } from "@material-ui/core";
import { useStyles, getPanelStyle } from "./AnchoredFloatingPanel.styles";
import { AnchoredFloatingPanelProps } from "./types";

const AnchoredFloatingPanel: React.FC<AnchoredFloatingPanelProps> = ({
  children,
  width = "360px",
  maxHeight = "70vh",
  toggleIcon,
  toggleLabel = "Panel",
  badgeCount = 0,
  className = "",
  panelClassName = "",
  toggleButtonClassName = "",
  defaultOpen = true,
  onToggle,
}) => {
  const classes = useStyles();
  const [isOpen, setIsOpen] = useState(defaultOpen);
  const containerRef = useRef<HTMLDivElement>(null);
  const handleToggle = () => {
    const newState = !isOpen;
    setIsOpen(newState);
    onToggle?.(newState);
  };

  return (
    <div
      ref={containerRef}
      className={`${classes.container} ${className}`}
    >
      <div
        className={`${classes.panel} ${panelClassName} ${
          classes.panelWithTransition
        } ${!isOpen ? classes.panelClosed : ""}`}
        style={getPanelStyle(width, maxHeight)}
      >
        {isOpen && children}
      </div>

      {!isOpen && (
        <div className={`${classes.toggleButton} ${toggleButtonClassName}`} onClick={handleToggle}>
          <Badge badgeContent={badgeCount} className={classes.badge}>
            {toggleIcon}
          </Badge>
          <Typography className={classes.toggleLabel}>
            {toggleLabel}
          </Typography>
        </div>
      )}
    </div>
  );
};

export default AnchoredFloatingPanel;